<template>
  <div class="bet-slip bet-slip-reverse">
    <div class="bet-slip-content with-title" :class="{'bgColorWhite' : isScanningCodeForMobile}">
      <bet-slip-title>{{ getTranslatedBetType('reverse') }}</bet-slip-title>
      <!-- Bet Line  -->
      <div v-for="bet in getReverses()" :key="bet.id">
        <bet-alert-message v-if="bet.error" error withoutIcon :description="parseBetErrorMessage(bet.error)" />
        <div v-else>
          <div class="bet-scroll-wrapper">
            <bet-slip-selection
              class="bet-slip-item-wrapper"
              v-for="selection in bet.bet.line_selections"
              :key="selection.id"
              :selection="selection"
              :showCheckbox="false"
              @onBuyPointChange="onRiskChange(bet)"
              @onRemove="removeBetFromSelections(selection.selection_identifier)"
              @accept="onRiskChange(bet)"
            ></bet-slip-selection>
          </div>
          <div class="bet-slip-item-wrapper pb-0" style="border: 0">
            <div class="row">
              <div class="col-6"></div>
              <div class="col-6">
                <bet-slip-risk-input
                  class="w-100"
                  :amount.sync="bet.bet.input_risk_amount"
                  @change="onRiskChange(bet)"
                  :min="getBetMinLimit(bet)"
                  :max="getBetMaxLimit(bet)"
                  type="RISK"
                ></bet-slip-risk-input>
              </div>
              <div class="col-12">
                <div
                  class="betslip-input-error error-1"
                  v-if="minErrorCondition(bet) && !minBetConditionByBet(bet)"
                  v-html="betSlipMinError(getBetMinLimit(bet), bet)"
                ></div>
                <div
                  class="betslip-input-error error-3 pt-1 p-0"
                  v-if="minBetConditionByBet(bet)"
                  v-html="minBetConditionError()"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <total-amounts
        class="mt-1"
        :totalBets="getTotalBetsCount()"
        :totalRiskAmount="getTotalRiskAmount()"
        :totalRiskAmountWithoutTax="getTotalRiskAmountWithoutTax()"
        :totalWinAmount="getTotalWinAmount()"
        :betOptionsResponse="getReverses()"
        :disable-place-bet-button="disablePlaceBetButton()"
      ></total-amounts>
    </div>
  </div>
</template>

<script>
import BetSlipMixin from './bet-slip-mixin';
import { mapActions, mapState } from 'vuex';
import { roundAmount } from '@/views/sports/components/bet-slip/bet-slip-utils';
import snq from 'snq';

export default {
  mixins: [BetSlipMixin],
  computed: {
    ...mapState({
      betSlipBetCount: state => state.betSlip.betSlipBetCount,
      isScanningCodeForMobile: state => state.settings.isScanningCodeForMobile,
    }),
  },
  methods: {
    ...mapActions({
      updateBetFreeWager: 'betSlip/updateBetFreeWager',
    }),
    onRiskChange(bet) {
      bet.bet.input_win_amount = this.getTotalWinAmount();
      this.notifyBetSlip(bet);
    },
    onOpenSpotsChange(bet) {
      this.notifyBetSlip(bet);
    },
    notifyBetSlip(bet) {
      this.createOrUpdateBet(
        this.createBet(
          bet.bet.type,
          '',
          bet.bet.input_risk_amount,
          bet.bet.input_win_amount,
          0,
          bet.bet.open_spots,
          null,
        ),
      );
    },

    getFactor(decimal) {
      let factor = 1;

      if (decimal <= 2) {
        decimal = decimal - 1;
        factor = decimal;
      }

      return factor;
    },
    /**
     *
     * Total Risk: (Risk A + Risk  B + Risk  C) * (Team Count -1)
     * Total Win: ((Win A +Win  B +Win  C)  2  (Team Count -1) ) - Total Risk
     * @returns {string}
     */
    getTotalRiskAmount() {
      let total = 0;
      this.getReverses().forEach(bet => {
        if (bet.bet.input_risk_amount !== '') {
          const input_risk_amount = parseFloat(bet.bet.input_risk_amount);
          const appliedRisk = parseFloat(
            this.$taxHelper.applyTaxToRiskInputHidden({
              input_risk_amount,
            }),
          );

          bet.bet.line_selections.forEach(line => {
            let decimal = this.americanToDecimal(line.odds);
            const factor = this.getFactor(decimal);

            const subTotal = appliedRisk / factor;
            total += subTotal;
          });
        }

        total = total * (this.betSlipBetCount - 1);
      });
      return this.roundAmount(total);
    },
    getTotalRiskAmountWithoutTax() {
      let total = 0;
      this.getReverses().forEach(bet => {
        if (bet.bet.input_risk_amount !== '') {
          const input_risk_amount = parseFloat(bet.bet.input_risk_amount);

          bet.bet.line_selections.forEach(line => {
            let decimal = this.americanToDecimal(line.odds);
            const factor = this.getFactor(decimal);

            const subTotal = input_risk_amount / factor;
            total += subTotal;
          });
        }

        total = total * (this.betSlipBetCount - 1);
      });
      return this.roundAmount(total);
    },
    getTotalWinAmount() {
      let total = 0;
      this.getReverses().forEach(bet => {
        if (bet.bet.input_risk_amount !== '') {
          const input_risk_amount = parseFloat(bet.bet.input_risk_amount);
          const appliedRisk = parseFloat(
            this.$taxHelper.applyTaxToRiskInputHidden({
              input_risk_amount,
            }),
          );

          bet.bet.line_selections.forEach(line => {
            let decimal = this.americanToDecimal(line.odds);
            const factor = this.getFactor(decimal);
            const subTotal = (parseFloat(roundAmount(appliedRisk)) / factor) * decimal;

            total += parseFloat(roundAmount(subTotal));
          });
        }

        total =
          parseFloat(roundAmount(total)) * 2 * (this.betSlipBetCount - 1) - roundAmount(this.getTotalRiskAmount());
      });
      return this.roundAmount(total);
    },
    getTotalBetsCount() {
      const length = snq(
        () => this.getReverses().filter(bet => parseFloat(bet.bet.input_risk_amount) > 0)[0].line_selections.length,
      );

      if (length === 4) {
        return 6;
      }
      return length;
    },
    disablePlaceBetButton() {
      return this.getReverses().some(bet => {
        return this.minBetConditionByBet(bet);
      });
    },
  },
  mounted() {
    this.updateBetFreeWager(0);
  },
};
</script>
